import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const checkMaintenance = createAsyncThunk(
    "maintenance/checkMaintenance",
    async ({ response }, { rejectWithValue }) => {
        if (response) {
            return {
                data: response,
            };
        }
        return rejectWithValue("No maintenance");
    }
);
const initialState = {
    data: null,
};
const maintenanceSlice = createSlice({
    name: "maintenance",
    initialState,
    reducers: {
        clearMaintenance: (state) => {

            state.data = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(checkMaintenance.fulfilled, (state, action) => {

                state.data = action.payload.data;
            })
            .addCase(checkMaintenance.rejected, (state) => {
            });
    },
});

export const { clearMaintenance } = maintenanceSlice.actions;
export default maintenanceSlice.reducer;
